import { ReturnRequestLogDto } from "@babackapp/private-api-client/types";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@babackapp/ui/components/accordion";
import ActivityWrapper from "./activity-wrapper";
import ActivityIconWrapper from "./activity-icon-wrapper";
import ActivityContentWrapper from "./activity-content-wrapper";
import { ActivityItemHeader } from "./activity-item-header";
import useTranslation, {
  Translation
} from "@babackapp/translations/use-translation";
import shippingBoLogo from "@/assets/integrations/shippingbo-icon.png";

type ShippingBoActivityProps = {
  activity: ReturnRequestLogDto;
};

export default function ShippingBoActivity({ activity }: ShippingBoActivityProps) {
  const t = useTranslation();
  const params = activity.params as { error?: string; response?: object | string, newState: string };
  let formattedResult: string | undefined = undefined;
  if (params.response !== undefined) {
    try {
      formattedResult = JSON.stringify(
        typeof params.response === "string"
          ? JSON.parse(params.response)
          : params.response,
        null,
        2,
      );
    } catch {
      formattedResult =
        typeof params.response === "string"
          ? params.response
          : String(params.response);
    }
  }
  return (
    <ActivityWrapper>
      <ActivityIconWrapper>
        <img src={shippingBoLogo} className="size-4" alt="ShippingBo logo" />
      </ActivityIconWrapper>
      <ActivityContentWrapper>
        <div className="flex items-center gap-2 flex-1 justify-between w-full">
          <Accordion type="single" collapsible className="flex-1">
            <AccordionItem value="item-1" className="border-0">
              <AccordionTrigger className="p-0 w-full">
                <ActivityItemHeader
                  title=""
                  timestamp={activity.date}
                  description={null}
                >
                  <div className="flex flex-col gap-0">
                    <div className="flex items-center gap-2">
                      <span>
                        Shippingbo: {t(`activities.shippingBo.${params.newState}` as Translation) || ''}
                        {params.error && t("misc.error")}
                      </span>
                    </div>
                  </div>
                </ActivityItemHeader>
              </AccordionTrigger>
              <AccordionContent>
                {params.error && (
                  <div className="text-xs text-red-600 mt-2">
                    <span className="font-medium">{t("misc.error")} : </span>
                    {params.error}
                  </div>
                )}
                {formattedResult && (
                  <pre className="mt-2 rounded-md bg-muted p-4 text-xs overflow-x-auto whitespace-pre-wrap">
                    {formattedResult}
                  </pre>
                )}
              </AccordionContent>
            </AccordionItem>
          </Accordion>
        </div>
      </ActivityContentWrapper>
    </ActivityWrapper>
  );
}
